import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { viewBox: "0 0 4.233 4.233" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M2.117 0a2.117 2.117 0 110 4.233 2.117 2.117 0 010-4.233zM3.1 1.755a.253.253 0 10-.358-.358l-.895.895-.358-.358a.253.253 0 10-.358.358l.537.537a.253.253 0 00.358 0z",
  fill: "currentColor",
  "fill-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }